'use client'

import { CSSVariablesResolver, MantineProvider } from '@mantine/core'
import { mantineTheme } from '../utils/mantineTheme'

const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    '--mantine-color-default-border': 'var(--mantine-color-zinc-2)',
    '--mantine-color-text': 'var(--mantine-color-zinc-10)',
    '--mantine-color-black': 'var(--mantine-color-zinc-10)',
  },
  dark: {},
})

export default function MantineProviderWrapper({ children }: { children: React.ReactNode }) {
  return (
    <MantineProvider theme={mantineTheme} cssVariablesResolver={cssVariablesResolver}>
      {children}
    </MantineProvider>
  )
}
